import React, { useState } from "react";
import { URL_CONSTANTS } from "../../axios/urlLinksThemes";
import { IGOVERNER } from "../../shared/commonUtils";
import { httpGet } from "../../axios/axiosUtils";

const useGetGovernorRate = () => {
  const [governorData, setGovernorData] = useState<IGOVERNER[]>([]);
  const getGovernorRate = async () => {
    try {
      const response = await httpGet(URL_CONSTANTS.get("URL_GET_GOVERNER")!);

      if (response.type !== "error") {
        setGovernorData(response);
      } else {
      }
    } catch (error) {}
  };

  return {
    governorData,
    getGovernorRate,
  };
};

export default useGetGovernorRate;
